/** @format */

import { createAction, props } from '@ngrx/store';
import { AvailableWarrantiesResponse, SelectedWarranty } from '@pdp/data-access/interfaces';

export const warrantySelectionDrawerOpened = createAction(
	'[Warranty Selection Drawer] Drawer Opened'
);

export const warrantyCallStarted = createAction('[Conditional Warranties Fetch] API Call Started');

export const warrantyCallSuccessful = createAction(
	'[Fetch Warranties] API Call Successful',
	props<{
		availableWarrantiesResponse: AvailableWarrantiesResponse;
	}>()
);

export const warrantyCallErrored = createAction('[Fetch Warranties] API Call Errored');

export const saveSelectionClicked = createAction(
	'[Warranty Selection Drawer] Save Selection Clicked',
	props<{
		selectedWarranty: SelectedWarranty;
	}>()
);

export const autoSelectionIneligibleSkuResolved = createAction(
	'[Warranties Auto Selection] Ineligible Product SKU Resolved',
	props<{
		selectedWarranty: SelectedWarranty;
	}>()
);

export const autoSelectionPlanFound = createAction(
	'[Warranty Auto-Selection] Auto-Selectable Plan Found',
	props<{
		selectedWarranty: SelectedWarranty;
	}>()
);

export const autoSelectionNoPlanFound = createAction(
	'[Warranty Auto-Selection] No Auto-Selectable Plan Found',
	props<{
		selectedWarranty: SelectedWarranty;
	}>()
);
